import React, { useContext } from "react";
import axios from "axios";
import { Row, Col, FormGroup, FormControl, FormLabel, Form } from "react-bootstrap";
import { useWizard } from "./WizardContext";
import Select from "react-select";
import { useGuestContext } from "../../../../contexts/GuestContext";
import LanguageToggle from "../LanguageToggle";
import SweetAlert from "react-bootstrap-sweetalert";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
import cuteVege1 from "../../../../assets/img/baolinPrivate/cute_vege1.png";
import cuteVege2 from "../../../../assets/img/baolinPrivate/cute_vege2.png";
import { VEGE_FEST_SLOTS, getSlotLabel } from "../../../../config/vegeFest2026";
const Step1 = React.forwardRef((props, ref) => {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    chinesename, setChinesename,
    email, setEmail,
    phone, setPhone,
    relatives, setRelatives,
    timeslot, setTimeslot

  } = useWizard();

  const { language } = useGuestContext();

  //define error messages
  const [firstnameError, setFirstnameError] = React.useState(null);
  const [lastnameError, setLastnameError] = React.useState(null);
  const [emailError, setEmailError] = React.useState(null);
  const [phoneError, setPhoneError] = React.useState(null);
  const [chinesenameError, setChinesenameError] = React.useState(null);
  const [timeslotError, setTimeslotError] = React.useState(null);
  // Remaining places per entry slot, so a full one cannot be picked.
  const [slotAvailability, setSlotAvailability] = React.useState([]);

  React.useEffect(() => {
    axios.get(`${process.env.REACT_APP_SERVER_URL}/vegefest/timeslots`)
      .then((response) => {
        const slots = response.data.timeslots || [];
        setSlotAvailability(slots);

        // Start on the first slot that still has room, so most guests can just
        // move on. Never overrides a choice the guest has already made.
        setTimeslot((current) => current || (slots.find((slot) => !slot.full) || {}).value || null);
      })
      .catch((error) => {
        // Without the counts the buttons still work; they just show no numbers.
        console.error('Could not load entry slot availability:', error);
        setSlotAvailability([]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [relativesError, setRelativesError] = React.useState(null);
  
  //state for warning alert
  const [alertState, setAlertState] = React.useState(null);

  const handleCheckboxChange = (event, setSession) => {
    setSession(event.target.checked);
  };

  const handleRelativesChange = (option) => {
    setRelatives(option.value);
    // Clear any existing error when user selects a value
    setRelativesError(null);
    // Show warning alert when user selects a number
    setAlertState(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={language === "English" ? "Reminder" : "提醒"}
        onConfirm={() => setAlertState(null)}
        confirmBtnBsStyle="success"
        confirmBtnText={language === "English" ? "I Understand" : "我明白了"}
      >
        <strong>
          {language === "English" 
            ? "Please make sure the total size of your group should also include yourself."
            : "参加总人数也包括您自己本人"
          }
        </strong>
      </SweetAlert>
    );
  };

  const handleNameChange = (value, setName, setError, isChineseName = false) => {
    // Regular expression for non-Chinese names: allows letters, spaces, hyphens, and apostrophes
    const nameRegex = /^[A-Za-z\s'-]+$/;
    // Regular expression for Chinese names: allows Chinese characters (including simplified and traditional), spaces, and common name characters
    const chineseNameRegex = /^[\u4e00-\u9fa5\s·]+$/;

    let isValid = isChineseName ? chineseNameRegex.test(value) : nameRegex.test(value);

    if (!isValid && value !== "") {
      setError(
        <small className="text-danger">
          {language === "English"
            ? isChineseName
              ? "Invalid characters. Only Chinese characters are allowed."
              : "Invalid characters. Only letters, spaces, hyphens, and apostrophes are allowed."
            : isChineseName
              ? "包含无效字符。只允许中文字符。"
              : "包含无效字符。只允许字母、空格、连字符和撇号。"
          }
        </small>
      );
    } else {
      setError(null);
    }
    setName(value);
  };
  const isValidated = () => {
    console.log("hey");
    // var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // re.test(email) === false
    //   ? setEmailError(
    //     <small className="text-danger">
    //       {language === "English" ? "Invalid email format. A correct format looks like john@doe.com." : "電子郵件格式不正確  正確格式類似於john@doe.com."}
    //     </small>
    //   )
    //   : setEmailError(null);
    //check firstname
    (firstname === null || firstname.trim() === "")
      ? setFirstnameError(
        <small className="text-danger">{language === "English" ? "First name is required." : "未填寫英文名"}</small>
      )
      : setFirstnameError(null);

    //check lastname
    (lastname === null || lastname.trim() === "")
      ? setLastnameError(
        <small className="text-danger">{language === "English" ? "Last name is required." : "未填寫英文姓"}</small>
      )
      : setLastnameError(null);

    (phone === null || phone.trim() === "")
      ? setPhoneError(
        <small className="text-danger">{language === "English" ? "Please enter a contact phone number." : "請填息聯繫電話以方便聯絡."}</small>
      )
      : setPhoneError(null);

    //check relatives (group size)
    (relatives === null || relatives === undefined)
      ? setRelativesError(
        <small className="text-danger">{language === "English" ? "Please select group size." : "請選擇隨行人數"}</small>
      )
      : setRelativesError(null);

    //check entry time slot
    (timeslot === null || timeslot === undefined)
      ? setTimeslotError(
        <small className="text-danger">{language === "English" ? "Please choose an entry time." : "請選擇入場時段"}</small>
      )
      : setTimeslotError(null);

    // var gd = gender !== null;
    // var em = re.test(email) === true;
    var fn = !(firstname === null || firstname.trim() === "");
    var ln = !(lastname === null || lastname.trim() === "");
    var ph = !(phone === null || phone.trim() === "");
    var rel = !(relatives === null || relatives === undefined);
    var ts = !(timeslot === null || timeslot === undefined);
    var valid = fn && ln && ph && rel && ts;
    return valid;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));


  const relativesOptions = Array.from({ length: 15 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));

  return (
    <>
      {alertState}
      <div className="wizard-step" ref={ref}>
        <p className="text-center mb-2 font-weight-bold">
          <img src={cuteVege1} alt="Company Logo" width="40" className="mr-3" />
          {language === "English" ? "Personal Information" : "請提供以下個人信息"}
          <img src={cuteVege2} alt="Company Logo" width="40" className="ml-3" />
        </p>
        <hr />
        <LanguageToggle />
        <hr />
      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "First Name (Required)" : "英 文 名（必填）"}<span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              type="text"
              name="firstname"
              placeholder="ex: Mike"
              maxLength="30"
              value={firstname}
              onChange={(event) => handleNameChange(event.target.value, setFirstname, setFirstnameError)}
            />
            {firstnameError}
          </FormGroup>
        </Col>
        <Col md={5}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Last Name (Required)" : "英 文 姓（必填）"}<span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              type="text"
              name="lastname"
              maxLength="30"
              placeholder="ex: Andrew"
              value={lastname}
              onChange={(event) => handleNameChange(event.target.value, setLastname, setLastnameError)}
            />
            {lastnameError}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Chinese Name" : "中 文 姓 名"}
            </FormLabel>
            <FormControl
              type="text"
              name="chinesename"
              maxLength="30"
              placeholder={language === "English" ? "ex: Wukong" : "ex：悟空"}
              value={chinesename}
              onChange={(event) => handleNameChange(event.target.value, setChinesename, setChinesenameError, true)}
            />
            {chinesenameError}
          </FormGroup>
        </Col>
        <Col md={{ span: 5 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Phone Number (Required for contact)" : "電 話 號 碼（必填，聯絡用）"} <span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              type="number"
              name="phone"
              maxLength="30"
              placeholder="ex: 0433233343"
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
            />
            {phoneError}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Email (optional for contact)" : "電 子 郵 件（聯絡用）"}
            </FormLabel>
            <FormControl
              type="email"
              name="email"
              maxLength="50"
              placeholder="ex: wukong@baolin.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            {emailError}
          </FormGroup>
        </Col>
        <Col md={{ span: 5}}>
          <FormGroup>
          <FormLabel>
              {language === "English" ? "Group Size (People Coming Along and yourself)" : "隨行人数（包括自己）"} <span className="text-danger">*</span>
            </FormLabel>
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              name="relativesSelect"
              value={relativesOptions.find((option) => option.value === relatives)}
              onChange={handleRelativesChange}
              options={relativesOptions}
              placeholder={language === "English" ? "Select number" : "选择人数"}
            />
            {relativesError}
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={{ span: 10, offset: 1 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Entry time" : "入場時段"} <span className="text-danger">*</span>
            </FormLabel>
            <p className="text-muted mb-2" style={{ fontSize: '0.9em' }}>
              {language === "English"
                ? "Entry is staggered this year. Please pick the time your whole group will arrive."
                : "今年採分批入場，請選擇您整組預計抵達的時段。"}
            </p>
            <div className="d-flex flex-wrap">
              {VEGE_FEST_SLOTS.map((slot) => {
                const info = slotAvailability.find((item) => item.value === slot.value);
                const isFull = Boolean(info && info.full);
                const selected = timeslot === slot.value;
                return (
                  <button
                    key={slot.value}
                    type="button"
                    disabled={isFull}
                    aria-pressed={selected}
                    onClick={() => { setTimeslot(slot.value); setTimeslotError(null); }}
                    className="btn mr-2 mb-2 px-4 py-3"
                    style={{
                      minWidth: '175px',
                      // #87CB16 is the wizard's own green (card-wizard[data-color="green"]),
                      // so the selected slot matches the step bar above it.
                      border: selected ? '2px solid #87CB16' : '1px solid #ccc',
                      borderRadius: '8px',
                      backgroundColor: isFull ? '#f1f1f1' : selected ? '#87CB16' : 'white',
                      color: isFull ? '#999' : selected ? 'white' : '#333',
                      fontWeight: selected ? 'bold' : 'normal',
                      cursor: isFull ? 'not-allowed' : 'pointer',
                      boxShadow: selected ? '0 2px 8px rgba(135, 203, 22, 0.3)' : 'none'
                    }}
                  >
                    {/* The time is the thing being chosen, so it leads the button. */}
                    <div style={{ fontSize: '1.45rem', fontWeight: 700, lineHeight: 1.2, letterSpacing: '0.3px' }}>
                      {getSlotLabel(slot)}
                    </div>
                    {info && info.capacity !== null && (
                      <small style={{ display: 'block', marginTop: '6px', fontSize: '0.85rem', opacity: 0.9 }}>
                        {isFull
                          ? (language === "English" ? "Full" : "已額滿")
                          : (language === "English" ? `${info.remaining} places left` : `尚餘 ${info.remaining} 位`)}
                      </small>
                    )}
                  </button>
                );
              })}
            </div>
            {timeslotError}
          </FormGroup>
        </Col>
      </Row>
      </div>
    </>
  );
});

export default Step1;
